import React from "react";
import {
  StudentChart,
  InviteChart,
  DateRangePicker,
  SideMenu,
  BackHeader,
} from "./../../components";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import { useNavigate } from "react-router-dom";
import ProfileImage from "./../../../assets/images/ProfileImage.png";
let AddStudentAnalytics = (props) => {
  const navigate = useNavigate();
  let TableData = [
    {
      date: "JAN 4, 2022",
      name: "Sallie Gulgowski",
      country: "burnside",
      cource: 2,
      price: 200,
    },
    {
      date: "JAN 4, 2022",
      name: "Benjamin T. Wilbanks",
      country: "burnside",
      cource: 0,
      price: 0,
    },
    {
      date: "JAN 4, 2022",
      name: "Idell Abernathy Sr.",
      country: "burnside",
      cource: 0,
      price: 0,
    },
    {
      date: "JAN 4, 2022",
      name: "Alyssa A.",
      country: "burnside",
      cource: 5,
      price: 1000,
    },
    {
      date: "DEC 30, 2022",
      name: "Thomas L.",
      country: "burnside",
      cource: 3,
      price: 900,
    },
    {
      date: "DEC 29, 2022",
      name: "William A. Clarke",
      country: "burnside",
      cource: 0,
      price: 0,
    },
  ];
  return (
    <SideMenu>
      <div className="page-container">
        <BackHeader backHanler={() => navigate(-1)} />
        <div className="analytics-graph-main">
          <div className="graph-filter-main">
            <p className="analytics-graph-heading">Student Buy Courses - 25</p>
            <div className="analytics-graph-filter-header">
              <p className="analytics-graph-header-date">Jan-2022</p>
              <select className="analytics-graph-filter-dropdown">
                <option value="Monthly">Monthly</option>
                <option value="Weekely">Weekely</option>
                <option value="Yearly">Yearly</option>
              </select>
            </div>
          </div>
          <StudentChart />
        </div>
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            <Grid item xl={8} lg={12} md={12} sm={12} xs={12}>
              <div className="analytics-graph-main">
                <div className="graph-filter-main">
                  <p className="analytics-graph-heading">
                    Total Invite people - 500
                  </p>
                  <div className="analytics-graph-filter-header">
                    <p className="analytics-graph-header-date">Jan-2022</p>
                    <select className="analytics-graph-filter-dropdown">
                      <option value="Monthly">Monthly</option>
                      <option value="Weekely">Weekely</option>
                      <option value="Yearly">Yearly</option>
                    </select>
                  </div>
                </div>
                <InviteChart />
              </div>
            </Grid>
            <Grid item xl={4} lg={12} md={12} sm={12} xs={12}>
              <div className="analytics-graph-main">
                <div className="graph-filter-main">
                  <p className="analytics-graph-heading">
                    Admin earning - $3000
                  </p>
                  <div className="analytics-graph-filter-header">
                    <select className="analytics-graph-filter-dropdown">
                      <option value="Monthly">Monthly</option>
                      <option value="Weekely">Weekely</option>
                      <option value="Yearly">Yearly</option>
                    </select>
                  </div>
                </div>
                <InviteChart />
              </div>
            </Grid>
          </Grid>
        </Box>
        <br />
        <br />
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            <Grid item xl={3} lg={3} md={6} sm={6} xs={12}>
              <div>
                <p className="header-input-heading">Search by name</p>
                <input
                  type="text"
                  className="header-input"
                  placeholder="Search by name"
                />
              </div>
            </Grid>
            <Grid item xl={3} lg={3} md={6} sm={6} xs={12}>
              <div>
                <p className="header-input-heading">Search by Country</p>
                <input
                  type="text"
                  className="header-input"
                  placeholder="Search by Country"
                />
              </div>
            </Grid>
            <Grid item xl={3} lg={3} md={6} sm={6} xs={12}>
              <DateRangePicker />
            </Grid>
            <Grid item xl={3} lg={3} md={6} sm={6} xs={12}>
              <div className="analytics-graph-header">
                <p className="analytics-graph-header-date">Jan-2022</p>
                <select className="analytics-graph-filter-dropdown">
                  <option value="Monthly">Monthly</option>
                  <option value="Weekely">Weekely</option>
                  <option value="Yearly">Yearly</option>
                </select>
              </div>
            </Grid>
          </Grid>
        </Box>
        <br />
        <div className="table-container">
          <div className="table-data-container">
            <table>
              <thead>
              <tr>
                <th className="analytics-add-student-table-id-heading">ID</th>
                <th className="analytics-add-student-table-date-heading">
                  date
                </th>
                <th className="analytics-add-student-table-invite-people-heading">
                  Invite People
                </th>
                <th className="analytics-add-student-table-country-heading">
                  Country
                </th>
                <th className="analytics-add-student-table-buy-course-heading">
                  Buy Cource
                </th>
                <th className="analytics-add-student-table-price-heading">
                  Price
                </th>
              </tr>
              </thead>
              {TableData.map((tableValue, tableIndex) => {
                return (
                  <tr key={tableIndex}>
                    <td className="table-id-data">{tableIndex + 1}</td>
                    <td className="table-data">{tableValue.date}</td>
                    <td className="table-data">
                      <div className="analytics-add-student-table-invite-people-data">
                        <img src={ProfileImage} className="analytics-add-student-table-invite-people-profile-image"/>
                        {tableValue.name}
                      </div>
                    </td>
                    <td className="table-data">{tableValue.country}</td>
                    <td className="table-center-data">{tableValue.cource}</td>
                    <td className="table-center-data">
                      {tableValue.price > 0 && "$"}
                      {tableValue.price}
                    </td>
                  </tr>
                );
              })}
            </table>
          </div>
          <div className="table-pagination-main">
            <Stack spacing={2}>
              <Pagination count={10} variant="outlined" shape="rounded" />
            </Stack>
          </div>
        </div>
      </div>
    </SideMenu>
  );
};
export default AddStudentAnalytics;
